module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header-top sticky-front-top"
  }, [_c('nav', {
    staticClass: "navbar navbar-transparent navbar-absolute"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })]), _c('router-link', {
    attrs: {
      "to": {
        name: 'body'
      }
    }
  }, [_vm._v("Trang chủ")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'body'
      }
    }
  }, [_vm._v("Liên hệ")])], 1)]), _c('div', {
    staticClass: "navbar-collapse"
  }, [_c('navbar-right')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e7ec4e5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/index.vue
// module id = 1601
// module chunks = 0